import i18next from "i18next";

const newInstance = i18next.createInstance({
  fallbackLng: "de",
  defaultNS: "translations",
  debug: false,
});

newInstance.init({
  react: {
    transSupportBasicHtmlNodes: true, // allow <br/> and simple html elements in translations
    transKeepBasicHtmlNodesFor: ["br", "strong", "i"], // don't convert to <1></1> if simple react elements
  },
});

const t = newInstance.t.bind(newInstance);

t.setNamespace = namespace => i18next.getFixedT(null, namespace);

const getLanguage = () => newInstance.language;

export { t, getLanguage };

export default newInstance;
